import { render, staticRenderFns } from "./AliIcon.vue?vue&type=template&id=7ad4891b&scoped=true&"
import script from "./AliIcon.vue?vue&type=script&lang=js&"
export * from "./AliIcon.vue?vue&type=script&lang=js&"
import style0 from "./AliIcon.vue?vue&type=style&index=0&id=7ad4891b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad4891b",
  null
  
)

export default component.exports